import { Routes } from '@angular/router';
import { NavBarComponent } from './shared/components/nav-bar/nav-bar.component';
import { PagesRoutes } from './shared/constants/pages-routes.constant';

export const PAGE_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: PagesRoutes.WORK_ITEMS,
  },
  {
    path: PagesRoutes.DASHBOARD,
    loadComponent: () =>
      import('./pages/dashboard/dashboard.component').then(
        (m) => m.DashboardComponent
      ),
    title: 'Factor Workflow - Dashboard',
  },
  {
    path: PagesRoutes.WORK_ITEMS,
    loadComponent: () =>
      import('./pages/views/views.component').then((m) => m.ViewsComponent),
    title: 'Factor Workflow - WorkItems',
  },
  {
    path: 'workItems/:id',
    loadComponent: () =>
      import('./pages/workitem/workitem.component').then(
        (m) => m.WorkitemComponent
      ),
    title: 'Factor Workflow - WorkItems',
  },
  {
    path: 'grouping/:id',
    loadComponent: () =>
      import('./pages/grouping/grouping.component').then(
        (m) => m.GroupingComponent
      ),
    title: 'Factor Workflow - Grouping',
  },
  {
    path: PagesRoutes.SETTINGS,
    loadComponent: () =>
      import('./pages/settings/settings.component').then(
        (m) => m.SettingsComponent
      ),
    title: 'Factor Workflow - Settings',
    loadChildren: () =>
      import('./pages/settings/settings.routes').then((r) => r.SETTINGS_ROUTES),
  },
  {
    path: 'documents/:documentId',
    loadComponent: () =>
      import('./pages/document-view/document-view.component').then(
        (m) => m.DocumentViewComponent
      ),
    title: `Factor Workflow - Document`,
  },
  {
    path: '**',
    redirectTo: PagesRoutes.WORK_ITEMS,
  },
];

export const routes: Routes = [
  {
    path: '',
    component: NavBarComponent,
    children: PAGE_ROUTES,
  },
];
